import { TipoEstabelecimentoEnum } from 'graphql/types.generated'

export const tipoEstabelecimentoLabelByValue: Record<TipoEstabelecimentoEnum, string> = {
  [TipoEstabelecimentoEnum.UBS]: 'Unidade Básica de Saúde',
  [TipoEstabelecimentoEnum.CEO]: 'Centro de Especialidades Odontológicas',
  [TipoEstabelecimentoEnum.UPA]: 'Unidade de Pronto Atendimento',
  [TipoEstabelecimentoEnum.POLICLINICA]: 'Policlínica',
}

export const tiposEstabelecimento = [
  { label: tipoEstabelecimentoLabelByValue.UBS, value: TipoEstabelecimentoEnum.UBS },
  { label: tipoEstabelecimentoLabelByValue.CEO, value: TipoEstabelecimentoEnum.CEO },
  { label: tipoEstabelecimentoLabelByValue.UPA, value: TipoEstabelecimentoEnum.UPA },
  { label: tipoEstabelecimentoLabelByValue.POLICLINICA, value: TipoEstabelecimentoEnum.POLICLINICA },
]
